import { useCallback } from 'react';
import { SelectRxDialog } from '../SelectRxDialog.jsx';
import { useContext } from '../../context.jsx';
import { useShapefileContext } from './shapefile-context.jsx';

export function ShapefileDialog() {
  const { tab } = useContext();
  const { isFiltering, setFiltering, setFilters } = useShapefileContext();

  const onCancel = useCallback(() => {
    setFiltering(false);
    setFilters([]);
  }, [setFiltering, setFilters]);

  const onSave = useCallback(
    (selection) => {
      setFiltering(false);
      setFilters(selection);
    },
    [setFiltering, setFilters],
  );

  return isFiltering ? (
    <SelectRxDialog
      title="Export Rx"
      selectedOption={tab}
      saveSelection={onSave}
      cancelSelection={onCancel}
    />
  ) : null;
}
